<template>
  <div class="w-full px-5">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item prop="first_name">
          <label class="text-sm block">First name:</label>
          <el-input class="w-full" v-model="form.first_name" type="text"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item prop="last_name">
          <label class="text-sm block">Last name:</label>
          <el-input class="w-full" v-model="form.last_name" type="text"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item prop="email">
          <label class="text-sm block">Email:</label>
          <el-input class="w-full" v-model="form.email" type="email"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item prop="phone">
          <label class="text-sm block">Phone:</label>
          <el-input class="w-full" v-model="form.phone" type="text"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mb-4">
      <el-col :xs="24" :sm="12">
        <el-form-item prop="gender">
          <label class="text-sm block">Gender:</label>
          <el-select class="w-full" v-model="form.gender" placeholder="Please select...">
            <el-option :label="'Male'" :value="'male'"></el-option>
            <el-option :label="'Female'" :value="'female'"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item prop="dob">
          <label class="text-sm block">Date of birth:</label>
          <el-date-picker class="w-full" v-model="form.dob" type="date" placeholder="Pick a Date"
                          format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mb-4">
      <el-col :xs="24" :sm="8">
        <el-form-item prop="newsletter">
          <label class="text-sm block">Subscribe to newsletter?</label>
          <el-switch v-model="form.newsletter"></el-switch>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="8">
        <el-form-item prop="verified">
          <label class="text-sm block">Verify?</label>
          <el-switch v-model="form.verified"></el-switch>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="8">
        <el-form-item prop="suspended">
          <label class="text-sm block">Suspend?</label>
          <el-switch v-model="form.suspended"></el-switch>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'CustomerForm',
  props: ['form'],
};
</script>

<style scoped>
  .w-full {
    width: 100% !important;
  }
</style>
